import { Pipe, PipeTransform, Injector } from '@angular/core';
import { ResourceService } from '../services/resource.service';
import { DiagnosedItem } from '../dataModels/diagnosed-item'

@Pipe({ name: "Localize" })
export class LocalizePipe extends DiagnosedItem implements PipeTransform {


    constructor(protected injector: Injector, private _resourceService: ResourceService) {
        super(injector);
    }

    transform(key: string, resourceName: string = void 0): string {
        /*
         * if an explicity resource name is provided, it overrides everything
         * ex : {{ 'SearchFor' | Localize : 'livetracking' }}
         */
        if (resourceName) {
            return this._resourceService.Localize(resourceName, key);
        }


        /*
         * if the resource service has a resource name, it's used. 
         */
        if (this._resourceService.resource) {
            return this._resourceService.transform(key);
        }


        /*
         * otherwise, the default resource file is used.
         * TODO : remove unnamed resource file and every module must used a named resource file
         */
        return this._resourceService.Localize(key);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/pipes/Localize.pipe.ts